<template>
  <div class="iptu-container">
    <!-- Cabeçalho -->
    <div class="card iptu-card mb-4">
      <div class="iptu-card-header d-flex justify-content-between align-items-center">
        <h4 class="mb-0">IPTU</h4>
        <div class="d-flex align-items-center flex-wrap">
          <span class="badge-campo"><strong>Pasta:</strong> {{ pasta }}</span>
          <span class="mx-2 text-white-50">|</span>
          <span class="badge-campo"><strong>Referência do Imóvel:</strong> {{ referencia }}</span>
        </div>
      </div>
    </div>

    <!-- Navegação por Ícones -->
    <CardNavLocacao :pasta="pasta" class="mb-4" />

    <!-- Parâmetros para Emissão -->
    <div class="card iptu-card mb-4">
      <div class="iptu-card-header">
        <h5 class="mb-0">Parâmetros para Emissão</h5>
      </div>
      <div class="iptu-card-body">
        <div class="row">
          <div class="col-md-4 mb-3">
            <label>Valor da parcela:</label>
            <input type="text" v-model="valorParcela" v-money="money" class="form-control" />
          </div>

          <div class="col-md-4 mb-3">
            <label>Total de parcelas:</label>
            <input type="number" v-model="totalParcelas" class="form-control" />
          </div>

          <div class="col-md-4 mb-3">
            <label>Parcelas em aberto:</label>
            <input type="number" v-model="parcelasAbertas" class="form-control" />
          </div>

          <div class="col-md-4 mb-3">
            <label>Saldo em aberto:</label>
            <input
              type="text"
              class="form-control input-destaque"
              :value="saldoAbertoFormatado"
              readonly
            />
          </div>

          <div class="col-md-4 mb-3">
            <label>Último pagamento:</label>
            <input type="date" v-model="ultimoPagamento" class="form-control" />
          </div>
        </div>

        <div class="text-center mt-4">
          <button @click="salvarIPTU" class="btn-salvar">
            Salvar
          </button>
        </div>
      </div>
    </div>
    <!-- Botão de acesso rápido - Buscar Locações -->
    <router-link to="/buscaLocacoes" class="fab-buscar-locacoes" title="Buscar Locações">
      <span class="fab-icone">
        <svg viewBox="0 0 24 24" fill="currentColor">
          <path d="M15.5 14h-.79l-.28-.27A6.471 6.471 0 0 0 16 9.5 6.5 6.5 0 1 0 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"/>
        </svg>
      </span>
      <span class="fab-texto">Buscar Locações</span>
    </router-link>

    <!-- Navegação por Ícones (rodapé) -->
    <CardNavLocacao :pasta="pasta" class="mt-4" />
  </div>
</template>

<script>
import axios from "axios";
import { VMoney } from "v-money";
import CardNavLocacao from "@/components/CardNavLocacao";

export default {
  name: "IPTUclientes",
  directives: { money: VMoney },
  components: { CardNavLocacao },
  data() {
    return {
      pasta: "",
      referencia: "",
      valorParcela: "",
      totalParcelas: "",
      parcelasAbertas: "",
   
      ultimoPagamento: "",
      money: {
        decimal: ",",
        thousands: ".",
        prefix: "R$ ",
        precision: 2,
      },
    };
  },
  mounted() {
      this.pasta=this.$route.params.id;
      this.get();
  },
  computed: {
  saldoAbertoCalc() {
    const valorParcela = parseFloat(
      (this.valorParcela || "0")
        .replace(/[R$\s.]/g, "")
        .replace(",", ".")
    );
    const parcelasAbertas = parseInt(this.parcelasAbertas || 0);
    return valorParcela * parcelasAbertas;
  },
  saldoAbertoFormatado() {
    if (isNaN(this.saldoAbertoCalc)) return "R$ 0,00";
    return this.saldoAbertoCalc
      .toLocaleString("pt-BR", { style: "currency", currency: "BRL" });
  }
},
  methods: {
       get(){
      axios.post('https://www2.royaljardim.com.br/sistema/locacao/getLocacao',{pasta:this.pasta})
        .then(r=>this.updateInfo(r.data))
    },
     updateInfo(data){
           this.pasta=data.LOC_PASTA||'';
           this.referencia=data.LOC_IMOVEL||'';
              this.valorParcela=data.LOC_IPTU_VALOR||'0,00';
                 this.totalParcelas=data.LOC_IPTU_TOTAL_PARCELAS||'0';
                   this.parcelasAbertas=data.LOC_IPTU_PARCELAS_ABERTAS||'0';
                    this.ultimoPagamento=data.LOC_IPTU_ULTIMO_PAGAMENTO||'';
     },
    salvarIPTU() {
      const formData = new FormData();
      formData.append("pasta", this.pasta);
      formData.append("referencia", this.referencia);
      formData.append("valorParcela", this.valorParcela.replace(/[R$\s.]/g, "").replace(",", "."));
      formData.append("totalParcelas", this.totalParcelas);
      formData.append("parcelasAbertas", this.parcelasAbertas);
      formData.append("saldoAberto", this.saldoAbertoCalc);
      formData.append("ultimoPagamento", this.ultimoPagamento);
     

      axios
        .post("https://www2.royaljardim.com.br/sistema/iptu/salvar", formData)
        .then(res => {
          console.log(res.data);
          alert("Dados de IPTU salvos com sucesso!");
        })
        .catch((e) => {
          console.error(e);
          alert("Erro ao salvar os dados do IPTU.");
        });
    },
  },
  
};
</script>

<style scoped>
/* ===== Container ===== */
.iptu-container {
  max-width: 1100px;
  margin: 0 auto;
}

/* ===== Cards ===== */
.iptu-card {
  border: 1px solid #e8e4e3;
  border-radius: 10px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.05);
  overflow: hidden;
}
.iptu-card-header {
  background: #4C1C17;
  color: #fff;
  padding: 12px 20px;
}
.iptu-card-header h4,
.iptu-card-header h5 {
  color: #fff;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}
.iptu-card-header h4 { font-size: 17px; }
.iptu-card-header h5 { font-size: 14px; }
.iptu-card-body {
  padding: 20px;
  background: #fff;
}
.badge-campo {
  font-size: 14px;
  color: #f0e5e3;
}

/* ===== Labels e Inputs ===== */
.iptu-card label {
  color: #4C1C17;
  font-weight: 600;
  font-size: 13px;
  margin-bottom: 5px;
}
.iptu-card .form-control {
  border-radius: 6px;
  border: 1px solid #ddd;
  padding: 9px 12px;
  font-size: 14px;
  transition: all 0.2s;
}
.iptu-card .form-control:focus {
  border-color: #4C1C17;
  box-shadow: 0 0 0 3px rgba(76,28,23,0.1);
}
.input-destaque {
  background: #4C1C17 !important;
  color: #fff !important;
  font-weight: 700;
  font-size: 16px;
  border: none !important;
  text-align: center;
}

/* ===== Botão Salvar ===== */
.btn-salvar {
  background: linear-gradient(135deg, #4C1C17, #6b2a22);
  color: #fff;
  border: none;
  padding: 12px 48px;
  font-size: 15px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 1px;
  border-radius: 8px;
  transition: all 0.2s;
  box-shadow: 0 4px 12px rgba(76,28,23,0.3);
}
.btn-salvar:hover {
  background: linear-gradient(135deg, #6b2a22, #8a3530);
  color: #fff;
  transform: translateY(-2px);
  box-shadow: 0 6px 18px rgba(76,28,23,0.4);
}

/* ===== FAB Buscar Locações ===== */
.fab-buscar-locacoes {
  position: fixed;
  bottom: 28px;
  right: 28px;
  z-index: 1000;
  display: flex;
  align-items: center;
  gap: 10px;
  background: linear-gradient(135deg, #4C1C17, #6b2a22);
  color: #fff;
  padding: 14px 22px;
  border-radius: 50px;
  text-decoration: none;
  font-weight: 600;
  font-size: 14px;
  letter-spacing: 0.5px;
  box-shadow: 0 6px 20px rgba(76,28,23,0.4);
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}
.fab-icone {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 26px;
  height: 26px;
  flex-shrink: 0;
}
.fab-icone svg {
  width: 24px;
  height: 24px;
}
.fab-texto {
  max-width: 0;
  overflow: hidden;
  white-space: nowrap;
  opacity: 0;
  transition: all 0.3s ease;
}
.fab-buscar-locacoes:hover {
  background: linear-gradient(135deg, #6b2a22, #8a3530);
  transform: translateY(-3px);
  box-shadow: 0 10px 28px rgba(76,28,23,0.5);
}
.fab-buscar-locacoes:hover .fab-texto {
  max-width: 140px;
  opacity: 1;
}
.fab-buscar-locacoes::after {
  content: "";
  position: absolute;
  inset: 0;
  border-radius: 50px;
  border: 2px solid #4C1C17;
  animation: fabPulse 2s infinite;
}
@keyframes fabPulse {
  0%   { transform: scale(1);   opacity: 0.8; }
  70%  { transform: scale(1.12); opacity: 0; }
  100% { transform: scale(1.12); opacity: 0; }
}
</style>